import React, { useState } from "react"
import { Mutation, FetchResult } from "react-apollo"
import { Formik } from "formik"
import { Input, Button, Form, Segment, Header, Divider, Message, Text, Flex } from "@jjordy/layout"
import Logo from "./Logo"
import Center from "./Elements/Center"
import styled, { createGlobalStyle } from "./styled"
import { Link, navigate, RouterProps } from "@reach/router"
import gql from "graphql-tag"

const authenticate = gql`
  mutation Authenticate($input: AuthenticateInput!) {
    authenticate(input: $input) {
      jwtToken
    }
  }
`

const Global = createGlobalStyle`
  body {
    background: ${(props) => props.theme.colors.lightGrey} !important;
  }
`

const LoginContainer = styled(Segment)`
  width: 350px;
  @media (max-width: 768px) {
    width: 98%;
    margin: auto;
  }
`

export interface LoginProps extends RouterProps {
  onSuccess: (values: any) => void
  path?: string
  exact?: boolean
}

interface Data {
  authenticate: {
    jwtToken: string
  }
}

interface Variables {
  input: any
}

type useStateError = null | string

class AuthenticateMutation extends Mutation<Data, Variables> {}

export default function Login({ onSuccess }: LoginProps) {
  const [error, setError] = useState<useStateError>(null)
  return (
    <Flex align="center" justify="center" style={{ height: "60vh" }}>
      <Global />
      <LoginContainer bg="success">
        <Center direction="column">
          <Logo />
        </Center>
        <Header fg="grey" as="h6">
          Login
        </Header>
        <AuthenticateMutation mutation={authenticate}>
          {(auth, { loading }) => {
            return (
              <div>
                {error && (
                  <Message bg="orange" icon="warning" onClose={() => setError(null)}>
                    <Text strong fg="white">
                      {error}
                    </Text>
                  </Message>
                )}
                <Formik
                  onSubmit={(values) =>
                    auth({
                      variables: { input: values }
                    })
                      .then(({ data }: FetchResult<Data>) => {
                        if (data) {
                          if (data.authenticate && data.authenticate.jwtToken) {
                            localStorage.setItem("token", data.authenticate.jwtToken)
                            onSuccess({ data })
                            navigate("/")
                          } else if (error === null) {
                            setError("Account not found or password incorrect.")
                          }
                        }
                      })
                      .catch((err) => setError(err.message))
                  }
                  initialValues={{ email: "", password: "" }}
                  render={({ handleSubmit, handleChange, values, errors }) => (
                    <Form onSubmit={handleSubmit} loading={loading}>
                      <Input
                        name="email"
                        label="Email"
                        type="email"
                        onChange={handleChange}
                        error={errors.email}
                        message={errors.email}
                        value={values.email}
                      />
                      <Input
                        name="password"
                        type="password"
                        label="Password"
                        onChange={handleChange}
                        value={values.password}
                        mb={2}
                      />
                      <Button fluid type="submit" my={1} bg="success">
                        LOGIN
                      </Button>
                    </Form>
                  )}
                />
                <Divider />
                <Flex>
                  <Button
                    as={Link}
                    bg="red"
                    to="/forgot-password"
                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, width: "50%" }}
                  >
                    Forgot Password
                  </Button>
                  <Button
                    as={Link}
                    to="/signup"
                    bg="success"
                    style={{ width: "50%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: 0 }}
                  >
                    Signup
                  </Button>
                </Flex>
              </div>
            )
          }}
        </AuthenticateMutation>
      </LoginContainer>
    </Flex>
  )
}
